import type { FC } from 'react';
import { Input } from '@ui';

interface FlatInputProps {
  value: string;
  onChange: (value: string) => void;
}

const FlatInput: FC<FlatInputProps> = ({ value, onChange }) => (
  <Input
    classNameParent='order-page-input'
    classNameInput='custom-input'
    placeHolder='Квартира, подъезд, этаж, домофон'
    value={value}
    field='flat'
    inputType='text'
    onInputBlur={next => {
      onChange(next);
    }}
  />
);

export default FlatInput;
